import axios from "axios";

export const handleCepChange = async (cepValue) => {
  if (cepValue.length !== 8) return;

  try {
    // 🔹 Tenta primeiro o ViaCEP
    const response = await axios.get(`https://viacep.com.br/ws/${cepValue}/json/`);
    if (response.data.erro) throw new Error("CEP não encontrado no ViaCEP");
    return response.data;
  } catch (error) {
    // 🔸 Se der erro, tenta a BrasilAPI
    try {
      const res = await fetch(`https://brasilapi.com.br/api/cep/v1/${cepValue}`);
      if (!res.ok) throw new Error("CEP não encontrado");
      return await res.json();
    } catch (fallbackError) {
      console.error("Erro ao buscar CEP:", fallbackError);
      throw new Error("Não foi possível localizar o CEP em nenhum serviço.");
    }
  }
};
